import { render, staticRenderFns } from "./busOrg.vue?vue&type=template&id=d033494a&scoped=true&"
import script from "./busOrg.vue?vue&type=script&lang=js&"
export * from "./busOrg.vue?vue&type=script&lang=js&"
import style0 from "./busOrg.vue?vue&type=style&index=0&id=d033494a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d033494a",
  null
  
)

export default component.exports